import { action, extendObservable } from 'mobx';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import FlagStore from './FlagStore';
import AsyncActionStore from './AsyncActionStore';
import { apiCall } from '../API';

const ISOLATION_APP_REGEX = /^https?:\/\/([\w]+.)?proofpointisolation.com/;
const DEFAULT_APPLICATIONS = [{
    icon: {
        kind: 'font:material',
        name: 'view_in_ar'
    },
    name: 'Isolation'
}];

export default class AppSwitcherStore {
    static PropType = PropTypes.shape({
        modal: FlagStore.PropType.isRequired,
        loadApps: PropTypes.func.isRequired,
        loadStatus: AsyncActionStore.PropType,
        apps: MobxPropTypes.arrayOrObservableArrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            icon: PropTypes.shape({
                kind: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            }),
        })).isRequired,
        selectedApp: PropTypes.number,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class AppSwitcherStore */{
            apiLoadApps: apiCall('/console/platformx/app-list'),
            loadStatus: new AsyncActionStore(),
            modal: new FlagStore(),
            apps: [],
            selectedApp: null,
        }, data);
    }

    loadApps = action(() => {
        if (!this.loadStatus.isLoading) {
            this.loadStatus.setLoading(this.apiLoadApps()
                .then((data) => {
                    this.apps.replace(data?.applications || DEFAULT_APPLICATIONS);
                    this.selectedApp = this.apps.findIndex((app) => ISOLATION_APP_REGEX.test(app.link));
                    return this.apps;
                })
                .catch((error) => {
                    window.console.error(error);
                    this.apps.replace(DEFAULT_APPLICATIONS);
                    this.selectedApp = 0;
                    return this.apps;
                }));
        }
        return this.loadStatus.promise;
    });
}
